// extracted by mini-css-extract-plugin
export default {"form":"AmountInputStep_form__JxmXW","infoSection":"AmountInputStep_infoSection__g3MrC","infoHeader":"AmountInputStep_infoHeader__G2IhA"};